import React from "react";
import PropTypes from "prop-types";
import "./LeftItems.less";
import Loading from "components/Loading";
const queryString = require("query-string");
import {checkTiao,noShowPage} from "dispatch";

class Music extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checkboxes: [],
        };
    }
    static propTypes = {
        show: PropTypes.string.isRequired,
        location: PropTypes.object.isRequired,
        handleSearchClick: PropTypes.func.isRequired,
        handleResetClick: PropTypes.func.isRequired,
        handleChangeClick: PropTypes.func.isRequired,
        instrument: PropTypes.array,
        loading: PropTypes.bool.isRequired,
    };
    handleChangeClick = e => {
        const { handleChangeClick } = this.props;
        handleChangeClick("instruments");
    };
    onChange(e) {
        if (e.target.checked) {
            let checks = this.state.checkboxes;
            checks.push(e.target.value);
            this.setState({
                checkboxes: checks,
            });
        } else {
            let checks = this.state.checkboxes;
            for (let i = 0; i < this.state.checkboxes.length; i++) {
                const element = this.state.checkboxes[i];
                if (e.target.value == element) {
                    checks.splice(i, 1);
                    this.setState({
                        checkboxes: checks,
                    });
                }
            }
        }
        this.handleSearchClick(this.state.checkboxes);
    }
    UNSAFE_componentWillReceiveProps (){
        const query = queryString.parse(this.props.location.search);
        const tiao =noShowPage.baseDecode(query.tiao);
        const instrument=checkTiao("instrument",tiao)
        let arry = [];
        if (instrument) {
            arry = instrument.split(",");
        }
        this.setState({
            checkboxes: arry,
        });
    }
    componentDidMount() {
        const query = queryString.parse(this.props.location.search);
        const tiao =noShowPage.baseDecode(query.tiao);
        const instrument=checkTiao("instrument",tiao)
        let arry = [];
        if (instrument) {
            arry = instrument.split(",");
        }
        this.setState({
            checkboxes: arry,
        });
    }
    handleSearchClick(val) {
        const { handleSearchClick } = this.props;

        handleSearchClick("instrument", this.state.checkboxes.toString());
    }
    handleResetClick = e => {
        this.setState({
            checkboxes: [],
        });
        const { handleResetClick } = this.props;
        handleResetClick("instrument");
    };
    renderCell(record) {
        const check = this.state.checkboxes;
        return (
            <li
                key={record.id}
                className="navList01__item navList01__item-check"
            >
                <label className="u-checkbox">
                    <input
                        type="checkbox"
                        value={record.id}
                        checked={
                            check.indexOf(record.id.toString()) == -1
                                ? ""
                                : "checked"
                        }
                        onChange={this.onChange.bind(this)}
                    />
                    <span>{record.title}</span>
                </label>
            </li>
        );
    }
    render() {
        const { show, instrument, loading } = this.props;
        const playClass =
            "accordionBox " + (show == "instruments" ? "is-open" : "is-close");
        const instrumentsData = instrument;
        return (
            <div className={playClass}>
                <p
                    className="accordionBox__title"
                    onClick={this.handleChangeClick.bind(this)}
                >
                    乐器
                </p>
                <div className="accordionBox__contents">
                    <ul className="navList01">
                        {instrumentsData != null ? (
                            instrumentsData.map(this.renderCell.bind(this))
                        ) : (
                            <Loading loading={loading} />
                        )}
                    </ul>
                    {/*<p className="navList__resetBtn">
                        <a
                            href="javascript:void(0)"
                            onClick={this.handleResetClick.bind(this)}
                        >
                            重新选取
                        </a>
                    </p>

                    <p className="navList__submit">
                        <button
                            className="u-submitSkin-s"
                            onClick={this.handleSearchClick.bind(this)}
                        >
                            开始查询
                        </button>
                    </p> */}
                </div>
            </div>
        );
    }
}
export default Music;
